import * as React from 'react';
import { G, Path } from 'react-native-svg';

function Mask() {
  return (
    <G stroke="#08204f" strokeLinecap="round" strokeMiterlimit={10}>
      <Path
        d="M32.73 123c3.93 2.79 8.93 3.83 13.79 4.64a235.78 235.78 0 0025.87 2.87c6.88.38 14.12.39 20.23-2.63 7.56-3.75 12.13-12.22 10.87-20.13a9.66 9.66 0 00-2.09-5c-2.11-2.39-5.64-3.1-8.91-3.62a309.7 309.7 0 00-42.6-3.77c-7.9-.15-18-.06-21.75 7.57-3.33 6.72-1.88 15.44 4.59 20.07z"
        fill="#d1ebf2"
        strokeWidth={1.03}
      />
      <Path
        d="M30.69 99.42c.84 1.81 3.11 2.36 5.08 2.7 9.78 1.65 19.6 3.29 29.51 3.66a222.37 222.37 0 0025.54-1c3.25-.25 6.66-.55 9.38-2.34M27.33 107.3c4.75 2.5 10.06 3.71 15.34 4.71a238.9 238.9 0 0051.2 4.07c3-.08 6-.25 8.7-1.59"
        fill="none"
        strokeWidth={1.03}
      />
      <Path
        d="M27.26 115.5c1.21 1.68 3.42 2.32 5.46 2.82A230.64 230.64 0 0097 124.67M100.93 102.34a15.25 15.25 0 007.68-.06c2.46-.82 4.63-2.91 4.86-5.49M97.15 125a115.65 115.65 0 0014.85-1.29 2.66 2.66 0 001.38-.48c.71-.62.59-1.74.41-2.66M30.86 99.13a14.78 14.78 0 01-3.41-.9 5 5 0 01-2.57-2.33 6.74 6.74 0 01-.47-2.71 4.52 4.52 0 01.25-1.83 1.68 1.68 0 011.34-1.1M26.72 113.45A15.16 15.16 0 0120.1 112a3.47 3.47 0 01-1.41-1.06 1.38 1.38 0 010-1.64"
        fill="none"
        strokeWidth={1.04}
      />
    </G>
  );
}

export default Mask;
